export default __webpack_public_path__ + "static/media/8_romeo_blue.c50ce92e.png";